import { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE, getAuthToken } from "../utils/api";
import type { User } from "../types/user";

const CACHE_KEY = "docfi_user";

export function useCurrentUser() {
  const [user, setUser] = useState<User | null>(() => {
    try {
      const cached = localStorage.getItem(CACHE_KEY);
      return cached ? JSON.parse(cached) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    if (!getAuthToken()) return;
    axios
      .get<User>(`${API_BASE}/users/me/`)
      .then((res) => {
        setUser(res.data);
        localStorage.setItem(CACHE_KEY, JSON.stringify(res.data));
      })
      .catch(() => {});
  }, []);

  const clearUser = () => {
    setUser(null);
    localStorage.removeItem(CACHE_KEY);
  };

  return { user, clearUser };
}
